export default "__VITE_ASSET__DwqGIVo7__"